import axios from '@plugins/axios'

const baseURL = 'user'

const state = {
  userData: [],
}

const getters = {
  userData: (state) => state.userData,
}

// atribuir um valor
const mutations = {
  updatePasswordUser(state, data) {
    state.userData = data
  },
}

const actions = {
  // commit usa a atribuicao criada no mutations
  async passwordChange({ commit }, password) {
    await axios
      .put(`/${baseURL}/password`, password)
      .then((res) => {
        commit('updatePasswordUser', res.data)
      })
      .catch((error) => {
        console.log(error)
      })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}
